// export const nounPath = (nounId: Number) => `/noun/${nounId}`;
export const nounPath = (nounId: Number) => `/auction/${nounId}`;
